import React, { useState } from "react";
import { InvestmentDailyStats } from "./InvestmentDailyStats";
import { InvestmentWeeklyStats } from "./InvestmentWeeklyStats";

interface InvestmentStatsTabsProps {
    skip?: boolean;
}

export const InvestmentStatsTabs: React.FC<InvestmentStatsTabsProps> = ({
    skip = false,
}) => {
    const [activeTab, setActiveTab] = useState<"daily" | "weekly">("daily");

    return (
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg">
            {/* Табы */}
            <div className="border-b border-gray-200 dark:border-gray-700">
                <nav className="flex -mb-px" aria-label="Tabs">
                    <button
                        onClick={() => setActiveTab("daily")}
                        className={`
                            flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm transition-colors
                            ${
                                activeTab === "daily"
                                    ? "border-blue-500 text-blue-600 dark:text-blue-400"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"
                            }
                        `}
                    >
                        Дневная статистика
                    </button>
                    <button
                        onClick={() => setActiveTab("weekly")}
                        className={`
                            flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm transition-colors
                            ${
                                activeTab === "weekly"
                                    ? "border-blue-500 text-blue-600 dark:text-blue-400"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"
                            }
                        `}
                    >
                        Недельная статистика
                    </button>
                </nav>
            </div>

            {/* Контент табов */}
            <div className="p-6">
                {activeTab === "daily" && <InvestmentDailyStats skip={skip} />}
                {activeTab === "weekly" && <InvestmentWeeklyStats skip={skip} />}
            </div>
        </div>
    );
};
